/* unplugin-vue-components disabled */import { render } from "./BuyList.vue?vue&type=template&id=46cf8f82"
import script from "./BuyList.vue?vue&type=script&lang=js"
export * from "./BuyList.vue?vue&type=script&lang=js"

import "./BuyList.vue?vue&type=style&index=0&id=46cf8f82&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__